// Material de Apoio do Ensino: PDF no bucket privado `ensino-materiais`
// (migration 025). O material guarda só { path, nome, tamanho } em `arquivo`;
// para abrir, gera URL assinada curta.

import { supabase } from './supabase';

const BUCKET = 'ensino-materiais';
const MAX_BYTES = 50 * 1024 * 1024;
const SIGNED_URL_TTL = 60 * 60;

function sanitizar(nome) {
  return nome.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-zA-Z0-9._-]/g, '_').slice(0, 80);
}

export async function uploadMaterial(file, materialId) {
  if (!file) throw new Error('Selecione o arquivo.');
  if (file.type !== 'application/pdf') throw new Error('Envie o material em PDF.');
  if (file.size > MAX_BYTES) throw new Error(`Arquivo com ${(file.size / 1024 / 1024).toFixed(1)} MB. O limite é 50 MB.`);
  const id = crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const path = `materiais/${materialId}/${id}-${sanitizar(file.name)}`;
  const { error } = await supabase.storage.from(BUCKET).upload(path, file, { cacheControl: '3600', upsert: false, contentType: 'application/pdf' });
  if (error) throw new Error('Não foi possível enviar o arquivo. Tente novamente.');
  return { path, nome: file.name, tamanho: file.size };
}

export async function urlMaterial(path) {
  const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(path, SIGNED_URL_TTL);
  if (error) throw new Error('Não foi possível abrir o arquivo.');
  return data.signedUrl;
}

export async function excluirArquivoMaterial(path) {
  if (!path) return;
  await supabase.storage.from(BUCKET).remove([path]);
}
